<svg class={$$props.class} viewBox="0 0 512 512">
  <path
    fill="currentColor"
    d="M464 32H336a48 48 0 00-48 48v128a48 48 0 0048 48h80v64a64 64 0 01-64
    64h-8a24 24 0 00-24 24v48a24 24 0 0024 24h8a160 160 0 00160-160V80a48 48 0
    00-48-48zm-288 0H48A48 48 0 000 80v128a48 48 0 0048 48h80v64a64 64 0 01-64
    64h-8a24 24 0 00-24 24v48a24 24 0 0024 24h8a160 160 0 00160-160V80a48 48 0
    00-48-48z" />
</svg>
